/* istanbul ignore file */
import { CommonModule } from '@angular/common';
import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { TravelType } from '@app/enums/travel-type.enum';
import { dateFormatPipe } from '@app/pipes/datepipe';
import { TravelRequestStateService } from '@services/state-management/travel-request-state.service';
import { FormGroupValueOf } from '@utility/utility';
import { Moment, utc } from 'moment';
import { RentalCarRequestDetailsFormGroup } from '../../../../form-groups/detail-form-groups/travel/rental-car-request.formgroup';

@Component({
    selector: 'medpace-car-rental-request-details-view',
    templateUrl: './car-rental-request-details-view.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, dateFormatPipe],
})
export class CarRentalRequestDetailsViewComponent {
    TravelType = TravelType;
    public readonly formValue = input.required<FormGroupValueOf<RentalCarRequestDetailsFormGroup>>();
    request$ = inject(TravelRequestStateService).getStaticState();
    public getDateFromMinutesSinceMidnight(minutesSinceMidnight: number | null): Moment | null {
        return minutesSinceMidnight ? utc().startOf('day').add(minutesSinceMidnight, 'minutes') : null;
    }
}
